module.exports = __webpack_public_path__ + "static/img/network_error.f6adfd08.png";